export default "__VITE_ASSET__$G4$pdt$__"